import defaultStyles from "./TabSelector.module.sass";
import React from "react";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";

const TabSelector = ({ tabs, selected, setSelected, styles }) => {
    const selectedStyles = styles ? styles : defaultStyles;
    const { i18n } = useGlobalValue();

    return (
        <div className={selectedStyles["tabs"]}>
            {(tabs || []).map((tabName, index) => (
                <div
                    key={index}
                    className={`${selectedStyles["tab"]} ${
                        selected === index ? selectedStyles["is-selected"] : ""
                    }`}
                    onClick={() => {
                        setSelected(index);
                    }}
                >
                    <small>{i18n`${tabName}`}</small>
                </div>
            ))}
        </div>
    );
};

export default TabSelector;
